module.exports = __webpack_public_path__ + "img/thumb-felicia-off.f0cb2698.jpg";